import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
})
/**
 * status Atom
 */
export class StatusComponent implements OnInit {
  @Input() status?: string;

  /**
   * on init
   */
  ngOnInit() {
    this.status = this.status?.toLowerCase();
  }
}
